var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9231 6.82353H3.38462C2.48696 6.82353 1.62607 7.18298 0.991331 7.82281C0.356592 8.46264 0 9.33044 0 10.2353V17.0588C0 17.9637 0.356592 18.8315 0.991331 19.4713C1.62607 20.1111 2.48696 20.4706 3.38462 20.4706H5.07692V27.2941C5.07692 27.7465 5.25522 28.1804 5.57259 28.5004C5.88996 28.8203 6.3204 29 6.76923 29H10.1538C10.6027 29 11.0331 28.8203 11.3505 28.5004C11.6679 28.1804 11.8462 27.7465 11.8462 27.2941V20.4706H16.9231L25.3846 27.2941V0L16.9231 6.82353ZM22 19.7882L18.6154 17.0588H3.38462V10.2353H18.6154L22 7.50588V19.7882ZM33 13.6471C33 16.5641 31.3754 19.2082 28.7692 20.4706V6.82353C31.3585 8.10294 33 10.7471 33 13.6471Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSga);
export default __webpack_public_path__ + "static/media/SGA.d543eb9e58ab89187c1658113a18c55d.svg";
export { ForwardRef as ReactComponent };